module.exports = __webpack_public_path__ + "static/media/ritik_naik.b90582ca.jpg";